import type React from 'react';
import styled from 'styled-components';
import { getHSLGradient } from './getHSLGradient';

export const GradientBar: React.FC = () => {
  const gradient = getHSLGradient(0, 120, 120);
  return <StyledBar $gradient={gradient} />;
};

const StyledBar = styled.div<{ $gradient: string }>`
  height: 100%;
  background: ${(props): string => props.$gradient};
`;
